import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'imagefiletype' })
export class ImageTypePipe implements PipeTransform {
  transform(FileType: any, args: any): string {
    let imageName;
    const type = (FileType === 'workbook' || FileType === 'json' || FileType === 'ppt' || 
     FileType === 'zip' || FileType === 'text' || FileType === 'Image' || FileType === 'download') ? 
     FileType : FileType.split('.')[1];
    const path = '../../../assets/images/'
     if (type) {
      switch (type.toString().toLowerCase()) {
        case 'pdf':
          imageName = 'pdf.png';
          break;
        case 'doc':
          imageName = 'doc.jpg';
          break;
        case 'docx':
          imageName = 'doc.jpg';
          break;
        case 'workbook':
          imageName = 'excel.jfif';
          break;
        case 'json':
          imageName = 'json.png';
          break;
        case 'ppt':
          imageName = 'ppt.png';
          break;
        case 'zip':
          imageName = 'zip.jfif';
          break;
        case 'text':
          imageName = 'text.png';
          break;
        case 'image':
          imageName = 'image.png';
          break;
        case 'png':
          imageName = 'image.png';
          break;
        case 'mp4':
          imageName = 'video.png';
          break;
        case 'download':
          imageName = 'Download.svg';
          break;
        default:
          imageName = 'pdf.png';
      } 
     } else {
      imageName = 'image.png';
     }
   return path + imageName;
  }

}
